import { Heading, Stack } from "@biom3/react";
import { Card, CardContent, Typography } from "@mui/material";

type AvailableSpinsCardProps = {
  spinsAvailable: number | string;
  className?: string;
  onOpenPrizeWheel?: () => void;
};

export const AvailableSpinsCard = ({
  spinsAvailable,
  className,
  onOpenPrizeWheel,
}: AvailableSpinsCardProps) => {
  const count = Number(spinsAvailable) || 0;
  return (
    <Card
      variant="outlined"
      sx={{
        width: "100%",
        height: "100px",
        background: "#252525",
        borderRadius: "12px",
        position: "relative",
      }}
      className={className}
    >
      <CardContent
        sx={{ p: 3, height: "100%", display: "flex", alignItems: "center" }}
      >
        <Stack
          direction="row"
          gap="base.spacing.x4"
          alignItems="center"
          sx={{
            display: "flex",
            width: "100%",
          }}
        >
          {/* Icon box */}
          <div className="relative flex items-center justify-center size-12 rounded-[8px] bg-[#131313] shrink-0">
            <img
              src="/assets/icons/pinwheel.svg"
              alt="Spins"
              className="w-6 h-6 object-contain"
            />
          </div>

          {/* Labels */}
          <Stack gap="base.spacing.x1" sx={{ width: "100%", flexGrow: 1 }}>
            <Typography variant="caption" color="text.secondary">
              SPINS LEFT
            </Typography>
            <Heading
              size="small"
              weight="bold"
              sx={{ color: "base.color.text.on-neutral" }}
            >
              {count}
            </Heading>
          </Stack>
          <div className="shrink-0 h-12 relative">
            {count > 0 && (
              <div
                aria-hidden
                className="absolute inset-0 pointer-events-none rounded-full"
                style={{
                  boxShadow: "0 0 0 0 rgba(0,0,0,0)",
                }}
              >
                <div
                  className="absolute inset-0 rounded-full"
                  style={{
                    background: "rgba(255,181,22,0.10)",
                    filter: "blur(8px)",
                  }}
                />
                <div
                  className="absolute inset-0 rounded-full border-2"
                  style={{
                    borderColor: "#ffb516",
                    boxShadow: "-4px -4px 12px 0 #ffb516",
                  }}
                />
              </div>
            )}
            <button
              type="button"
              onClick={count > 0 ? onOpenPrizeWheel : undefined}
              disabled={count <= 0}
              className={`relative bg-[#1c1c1c] text-neutral-50 h-12 px-5 rounded-full shadow-[0px_1px_3px_0px_rgba(0,0,0,0.16),0px_1px_3px_0px_rgba(0,0,0,0.32)] ${
                count <= 0 ? "opacity-50 cursor-not-allowed" : ""
              }`}
              aria-label="Open Prize Wheel"
              aria-disabled={count <= 0}
            >
              <span className="text-[14px] leading-[20px] font-medium whitespace-pre">
                {`Spin The Wheel • ${count}`}
              </span>
            </button>
          </div>
        </Stack>
      </CardContent>
    </Card>
  );
};
